<template>
  <div class="order-grid col-sm-12 col-md-12 col-lg-12 eh-ds">
    <div class="header2">
      <h1 class="title">Current Procedures</h1>
      <button type="button" @click="showAddProc">
        <font-awesome-icon :icon="['fas', 'plus-circle']" />
      </button>
    </div>
    <div v-if="isMobile()" :id="'procmodal-overlay-mobile' + patient.id" class="modal-overlay eh-popup-overlay" @click="closeProc" style="display: none;">
      <form
        class="container diagnosismodal mobile-proc-modal eh-popup-panel"
        @submit.prevent="saveProc"
        @click.stop
        :id="'procmodal' + patient.id"
      >
      <div class="form-group">
        <label>Procedure Description</label>
        <input
          required
          name="procCode"
          type="text"
          v-model="procSearchDescrip"
          @keyup.prevent="showProcSearch"
          placeholder="Type in your CPT description"
          autocomplete="off"
        />
        <div
          v-if="searchedProcs"
          :class="'searchresult' + patient.id"
          id="procsearchresult"
        >
          <div
            @click="
              officialProc = `${proc.code} ${proc.description}`;
              searchedProcs = null;
            "
            v-for="proc in searchedProcs"
            class="procList"
            :key="proc.procid"
          >
            <span id="procname">{{ `${proc.code} ${proc.description}` }}</span>
          </div>
        </div>
        <input
          type="text"
          id="officialProc"
          name="officialProc"
          placeholder="Official Procedure Name"
          v-model="officialProc"
          readonly
        />
      </div>
      <div class="form-group">
        <label>ICD-10 Description</label>
        <input
          type="text"
          name="icdCode"
          autocomplete="off"
          v-model="diagSearchDescrip"
          @input="showDiagSearch"
          :placeholder="
            icdSearch ? 'Type in your ICD code or a description' : 'Type in your ICD Code'
          "
        />
        <div
          v-if="searchedDiags"
          :class="'searchresult' + patient.id"
          id="diagsearchresult"
        >
          <div
            v-for="diag in searchedDiags"
            @click="
              diagSearchDescrip = `${diag.code} - ${diag.description}`;
              searchedDiags = null;
            "
            class="diagList"
            :key="diag.code"
          >
            <span>{{ `${diag.code} - ${diag.description}` }}</span>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>Date *</label>
        <input type="date" name="date" required />
      </div>
      <div class="form-group">
        <label>Instruction</label>
        <textarea name="instruction" rows="3"></textarea>
      </div>
      <div class="form-buttons">
        <button type="submit">Save</button>
        <button @click="closeProc">Cancel</button>
      </div>
      </form>
    </div>
    <div v-if="!isMobile()" :id="'procmodal-overlay' + patient.id" class="modal-overlay eh-popup-overlay" @click="closeProc" style="display: none;">
      <form
        :id="'procmodal' + patient.id"
        @submit.prevent="saveProc"
        @click.stop
        class="diagnosismodal col-sm-12 col-md-12 col-lg-12 eh-popup-panel"
      >
      <!-- <section class="modalclose">
                  <a href="#close" title="close Modal" id="amodalclose">X</a>
                </section> -->
      <div class="modaltop">
        <section class="diagtitlesec col-sm-12 col-md-6 col-lg-6">
          <h3>Procedure</h3>
        </section>
      </div>
      <div class="modalbottom">
        <!-- <div id="diagnostypeSec">
                    <label>Type:</label> <br />
                    <label>
                      <input type="checkbox" id="diagchkbox" />Diagnosis</label
                    ><br />
                    <label
                      ><input
                        type="checkbox"
                        id="procedurechkbox"
                      />Proceedure</label
                    >
                  </div> -->
        <div class="icd10second col-sm-12 col-lg-12">
          <div id="icdfirstopt" class="col-sm-12 col-md-4 col-lg-3">
            <label>Procedure Description</label>
            <!-- <label id="srchbylbl">{{icdSearch ? "Search By ICD-10 Description" : "Search By ICD-10 Code"}}</label
                      ><label id="switch"
                        ><input type="checkbox" id="toggleSearch" v-model="icdSearch"/></label> -->
            <br />
            <input
              required
              name="procCode"
              type="text"
              id="srchnlookupterms"
              title="cpt proc field"
              v-model="procSearchDescrip"
              placeholder="Type in your CPT description"
              @keyup.prevent="showProcSearch"
            />
            <input
              type="text"
              id="officialProc"
              name="officialProc"
              placeholder="Official Procedure Name"
              v-model="officialProc"
              readonly
            />
            <!-- <a href="#searchicon"
                        ><img
                          src="https://cdn4.iconfinder.com/data/icons/ionicons/512/icon-ios7-search-512.png"
                          width="20"
                          height="20"
                      /></a> -->
          </div>
          <div id="icdsectopt" class="col-sm-12 col-md-4 col-lg-3">
            <label>ICD-10 Description</label>
            <!-- <label id="srchbylbl">{{icdSearch ? "Search By ICD-10 Description" : "Search By ICD-10 Code"}}</label
                      ><label id="switch"
                        ><input type="checkbox" id="toggleSearch" v-model="icdSearch"/></label> -->
            <br />
            <input
              required
              name="icdCode"
              type="text"
              id="srchnlookupterms"
              title="icd-10 diagnosis field"
              v-model="diagSearchDescrip"
              :placeholder="
                icdSearch
                  ? 'Type in your ICD code or a description'
                  : 'Type in your ICD Code'
              "
              @keyup.prevent="showDiagSearch"
            />
          </div>
          <div id="icdthirdopt" class="col-sm-12 col-md-4 col-lg-3">
            <label>Date *</label><br />
            <input type="date" id="diagnosisDate" required name="date" />
          </div>
          <!-- <div id="icdfourthopt" class="col-sm-12 col-md-4 col-lg-3">
            <label>System Control Rating </label><br />
            <input type="number" id="controlnumber" min="0" max="4" name="syscontrol" />
          </div> -->
        </div>
        <div class="icd10fourth col-sm-12 col-lg-12">
          <div id="icdfirstopt" class="col-sm-12 col-md-4 col-lg-3">
            <label>Instruction</label>
            <textarea id="instruction" name="instruction" cols="100" type="text" />
          </div>
        </div>
        <div class="icd10thrid col-sm-12 col-lg-12">
          <ul class="list">
            <span v-if="searchedProcs.length > 0">Procedures</span>
            <span v-if="searchedDiags.length > 0">Diagnosis</span>
            <template v-if="activeSearch === 'procedure'">
              <li
                v-for="(procedure, index) in paginatedData"
                :key="index"
                class="list__item"
              >
                <a class="list__link" @click="clickProc(procedure)">
                  {{ index + 1 }}. {{ procedure.description }}
                </a>
              </li>
            </template>
            <template v-if="activeSearch === 'diagnosis'">
              <li
                v-for="(diagnosis, index) in paginatedData"
                :key="index"
                class="list__item"
              >
                <a class="list__link" @click="clickDiag(diagnosis)">
                  {{ index + 1 }}. {{ diagnosis.description }}
                </a>
              </li>
            </template>
          </ul>
          <div v-if="searchedProcs.length > 0">
            <button :disabled="pageNumber === 0" @click="prevPage" class="btn btn-prev">
              Previous
            </button>

            <input
              type="text"
              v-model="currPageNumber"
              id="currentPageNumber"
              style="width: 30px"
            />
            <label for="currentPageNumber"
              >/{{ pageCount() }}
              <button @click="toPage(currPageNumber - 1)" class="btn ml-2">
                Go
              </button></label
            >

            <button
              :disabled="pageNumber >= pageCount() - 1"
              @click="nextPage"
              class="btn btn-next"
            >
              Next
            </button>
          </div>

          <div v-if="searchedDiags.length > 0">
            <button :disabled="pageNumber === 0" @click="prevPage" class="btn btn-prev">
              Previous
            </button>

            <input
              type="text"
              v-model="currPageNumber"
              id="currentPageNumber"
              style="width: 30px"
            />
            <label for="currentPageNumber"
              >/{{ pageCount() }}
              <button @click="toPage(currPageNumber - 1)" class="btn ml-2">
                Go
              </button></label
            >

            <button
              :disabled="pageNumber >= pageCount() - 1"
              @click="nextPage"
              class="btn btn-next"
            >
              Next
            </button>
          </div>
        </div>
        <div class="icd10fifth col-sm-12 col-lg-12">
          <div id="icdsfrthopt" class="col-sm-12 col-md-12 col-lg-12">
            <input type="submit" id="savediagnbtn" value="Save" />
            <input type="button" id="canceldiagbtn" value="Cancel" @click="closeProc" />
          </div>
        </div>
      </div>
      <!--end Order Grid for Modal-->
      </form>
    </div>
    <template v-if="isMobile()">
      <div v-if="allProcs" class="table-container">
        <div class="accordion">
          <div
            v-for="(proc, index) in sortedProcedures"
            :key="'proc' + index"
            :id="'proc' + index"
            @click="showProc(index)"
            class="accordion-item"
          >
            <button class="accordion-button">
              {{ proc.procShorthand ? proc.procShorthand : proc.procedure_code }}
            </button>
            <div class="accordion-content">
              <p><b>Procedure: </b>{{ `${proc.procedure_code}` }}</p>
              <p><b>Diagnosis: </b>{{ `${proc.diagnosis_code}` }}</p>
              <p><b>Instruction: </b>{{ `${proc.instruction}` }}</p>
              <p><b>Nurse Signature: </b>
                <span v-if="proc.order_id && proc.order_id !== 0 && (!proc.nursesignature || proc.nursesignature === '') && proc.providersignature && proc.providersignature !== ''" 
                      class="sig-card" 
                      @click="openOrderModal(proc.order_id, proc.orddiagid)">
                  <div class="signature-badge" role="img" aria-label="Nurse signature required">
                    <span class="sig-text">Nurse<br>Signature</span>
                    <svg class="pen" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" style="transform: scaleX(-1); transform-origin: center;"> 
                      <g transform="translate(24,0) scale(-1,1)"> <path fill="white" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/> 
                      </g> 
                    </svg>
                  </div>
                </span>
                <span v-else>{{ (proc.order_id && proc.order_id !== 0) ? (proc.nursesignature || '') : 'N/A' }}</span>
              </p>
              <p><b>Provider Signature: </b>
                <span v-if="proc.order_id && proc.order_id !== 0 && proc.nursesignature && proc.nursesignature !== '' && (!proc.providersignature || proc.providersignature === '')" 
                      class="sig-card" 
                      @click="openOrderModal(proc.order_id, proc.orddiagid)">
                  <div class="signature-badge" role="img" aria-label="Provider signature required">
                    <span class="sig-text">Provider<br>Signature</span>
                    <svg class="pen" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" style="transform: scaleX(-1); transform-origin: center;"> 
                      <g transform="translate(24,0) scale(-1,1)"> <path fill="white" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/> 
                      </g> 
                    </svg>
                  </div>
                </span>
                <span v-else>{{ (proc.order_id && proc.order_id !== 0) ? (proc.providersignature || '') : 'N/A' }}</span>
              </p>
              <p>{{ `${proc.diagnosis_date} to ${proc.end_date}` }}</p>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="container">
        <table>
          <thead>
            <tr>
              <th>Procedure</th>
              <th>Diagnosis</th>
              <th>Instruction</th>
              <th>Date</th>
              <th>Nurse Signature</th>
              <th>Provider Signature</th>
            </tr>
          </thead>
          <tbody v-if="allProcs">
            <tr v-for="(proc, index) in sortedProcedures" :key="'proc' + index" style="position: relative;">
              <td data-label="Procedure" class="procrow">{{ proc.procedure_code }}</td>
              <td data-label="Diagnosis">{{ proc.diagnosis_code }}</td>
              <td data-label="Instruction">{{ proc.instruction }}</td>
              <td data-label="Date">
                {{
                  `${proc.diagnosis_date ? proc.diagnosis_date : "—"} to ${
                    proc.end_date ? proc.end_date : "—"
                  }`
                }}
              </td>
              <td data-label="Nurse Signature" style="position: relative; vertical-align: middle;">
                <span v-if="proc.order_id && proc.order_id !== 0 && (!proc.nursesignature || proc.nursesignature === '') && proc.providersignature && proc.providersignature !== ''" 
                      class="sig-card" 
                      @click="openOrderModal(proc.order_id, proc.orddiagid)">
                  <div class="signature-badge" role="img" aria-label="Nurse signature required">
                    <span class="sig-text">Nurse<br>Signature</span>
                    <svg class="pen" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" style="transform: scaleX(-1); transform-origin: center;"> 
                      <g transform="translate(24,0) scale(-1,1)"> <path fill="white" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/> 
                      </g> 
                    </svg>
                  </div>
                </span>
                <span v-else>{{ (proc.order_id && proc.order_id !== 0) ? (proc.nursesignature || '') : 'N/A' }}</span>
              </td>
              <td data-label="Provider Signature" style="position: relative; vertical-align: middle;">
                <span v-if="proc.order_id && proc.order_id !== 0 && proc.nursesignature && proc.nursesignature !== '' && (!proc.providersignature || proc.providersignature === '')" 
                      class="sig-card" 
                      @click="openOrderModal(proc.order_id, proc.orddiagid)">
                  <div class="signature-badge" role="img" aria-label="Provider signature required">
                    <span class="sig-text">Provider<br>Signature</span>
                    <svg class="pen" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" style="transform: scaleX(-1); transform-origin: center;"> 
                      <g transform="translate(24,0) scale(-1,1)"> <path fill="white" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/> 
                      </g> 
                    </svg>
                  </div>
                </span>
                <span v-else>{{ (proc.order_id && proc.order_id !== 0) ? (proc.providersignature || '') : 'N/A' }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <MedadminshortOrderTemplate
      v-model:modelValue="showOrderModal"
      :order="selectedOrder"
      @submitsig="handleSubmit"
    />
  </div>
</template>
<script>
import { CURR_API, OTHER_API } from "@/constants/apis";
import axios from "axios";
import { mapGetters } from "vuex";
import $ from "jquery";
import MedadminshortOrderTemplate from './MedadminshortOrderTemplate.vue';
import { usePrivilegesStore } from "@/stores/privileges";
import { PRIVILEGES } from "@/constants/privileges";
import { assertPrivilegeOrAlert } from "@/utils/privilegeGate";

export default {
  name: "CurrentProc",
  components: {
    MedadminshortOrderTemplate
  },
  data() {
    return {
      icdSearch: true,
      diagSearchCode: "", // ICD-10 search code value
      diagSearchDescrip: "", // ICD-10 search description (textfield) value
      searchedDiags: [], // List of ICD codes retrieved via icdSearch

      // showProc: false, // Checkbox that activates Procedure tab
      allProcs: null, // List of procedures already saved for patient
      procSearchDescrip: "", // CPT search descriptions (textfield) value
      searchedProcs: [], // List of CPT codes retrieved via procSearch
      pageNumber: 0,
      size: 5,
      currPageNumber: 1,
      paginatedData: [],
      activeSearch: "",
      officialProc: "",
      showOrderModal: false,
      selectedOrder: {},
    };
  },
  async mounted() {
    this.loadProcedures();
  },
  computed: {
    canOrderSign() {
      return usePrivilegesStore().effectiveGranted(PRIVILEGES.ORDER_SIGN);
    },
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    patient: function () {
      return this.allData.patient;
    },
    sortedProcedures: function () {
      if (!this.allProcs || !Array.isArray(this.allProcs)) {
        return [];
      }
      return [...this.allProcs].sort((a, b) => {
        const dateA = a.diagnosis_date ? new Date(a.diagnosis_date) : new Date(0);
        const dateB = b.diagnosis_date ? new Date(b.diagnosis_date) : new Date(0);
        if (dateA.getTime() !== dateB.getTime()) {
          return dateB.getTime() - dateA.getTime();
        }
        const idA = a.orddiagid || a.diagnosis_id || a.diagid || 0;
        const idB = b.orddiagid || b.diagnosis_id || b.diagid || 0;
        return idB - idA;
      });
    },
  },
  methods: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    showProc(index) {
      let entry = document.getElementById(`proc${index}`);
      entry.classList.toggle("active");
    },
    pageCount() {
      let l;
      if (this.activeSearch === "procedure") l = this.searchedProcs.length;
      if (this.activeSearch === "diagnosis") l = this.searchedDiags.length;
      let x = Math.ceil(l / this.size);
      return x;
    },
    paginateData() {
      let start = this.pageNumber * this.size,
        end = start + this.size;
      if (this.activeSearch === "procedure")
        this.paginatedData = this.searchedProcs.slice(start, end);
      else if (this.activeSearch === "diagnosis") {
        this.paginatedData = this.searchedDiags.slice(start, end);
      }
    },
    nextPage() {
      this.pageNumber++;
      this.currPageNumber = this.pageNumber + 1;
      this.paginateData();
    },
    prevPage() {
      this.pageNumber--;
      this.currPageNumber = this.pageNumber + 1;
      this.paginateData();
    },
    toPage(pageNumber) {
      this.pageNumber = pageNumber;
      this.paginateData();
    },
    async loadProcedures() {
      let content = {
        Diagnosis: {
          API_Meth: "PopulateDiagGrid",
          patientID: this.allData.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.gridhtml) {
            this.allProcs = res.data.data.filter(
              (proc) => proc.diagnosis_type === "Procedure"
            );
          } else {
            this.allProcs = null;
          }
        });
    },

    async saveProc() {
      let form = document.getElementById("procmodal" + this.patient.id);
      let content = {
        Diagnosis: {
          API_Meth: "InsertDiagnosis",
          ordernumber: 0,
          diagnosis_type: "Procedure",
          onset_exacerbation: "",
          diagnosisDate: form.elements["date"].value,
          diagControlRating: "",
          diagcode: form.elements["icdCode"].value,
          proccode: this.officialProc,
          procShorthand: form.elements["procCode"].value,
          pid: this.patient.externId,
          status: "Active",
          instruction: form.elements["instruction"].value,
          writer: this.allData.manager.name,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.result && res.data.result == "Inserted") {
            this.diagSearchCode = "";
            this.diagSearchDescrip = "";
            this.procSearchDescrip = "";
            this.officialProc = "";
            this.loadProcedures();
            alert("Procedure successfully added");
            this.closeProc();
          } else {
            alert(
              "Error with procedure insertion. Try again or contact an administrator."
            );
          }
        });
    },
    async showProcSearch() {
      this.activeSearch = "procedure";
      this.searchedProcs = [];
      this.searchedDiags = [];
      this.paginatedData = [];
      if (this.procSearchDescrip == "") {
        this.searchedProcs = [];
        this.searchDiags = [];
        this.paginatedData = [];
        return;
      }
      if (!isNaN(this.procSearchDescrip)) {
        let content = {
          Diagnosis: {
            API_Meth: "SearchProcedure-Code",
            searchterms: this.procSearchDescrip,
          },
        };
        await axios
          .post(CURR_API + "/tswebhook.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            if (res.data.result && res.data.result != "No Data Found") {
              this.searchedProcs = res.data.result;
            } else {
              this.searchedProcs = [];
            }
          });
      } else {
        let content = {
          Diagnosis: {
            API_Meth: "SearchProcedure-Description",
            description: this.procSearchDescrip,
          },
        };
        await axios
          .post(CURR_API + "/tswebhook.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            if (res.data.count) {
              if (res.data.result.msg) {
                alert("Error:" + res.data.result.msg);
              } else {
                this.searchedProcs = res.data.result;
                this.currPageNumber = 1;
                this.pageNumber = 0;
                this.paginateData();
              }
            } else {
              this.searchedProcs = [];
              this.paginatedData = [];
            }
          });
      }
    },
    async showDiagSearch() {
      this.activeSearch = "diagnosis";
      this.searchedProcs = [];
      this.searchedDiags = [];
      this.paginatedData = [];

      if (this.diagSearchDescrip == "") {
        this.searchedProcs = [];
        this.searchedDiags = [];
        this.paginatedData = [];
        return;
      }
      if (true) {
        let content = {
          action: "Search",
          searchTerm: this.diagSearchDescrip,
          ICDCode: "",
          ICDReleaseUrl: "",
        };
        await axios
          .post(CURR_API + "/icd_calls.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            if (res.data.result == 0) {
              this.searchedDiags = [];
            } else {
              this.searchedDiags = res.data.actualResults;
              this.currPageNumber = 1;
              this.pageNumber = 0;
              this.paginateData();
            }
          });
      }
      // else {
      //   let content = {
      //     "action": "CodeLookUp",
      //     "searchTerm": "",
      //     "ICDCode":
      //   }
      // }
    },
    clickDiag(diag) {
      this.diagSearchCode = diag.code;
      this.diagSearchDescrip = diag.code + " - " + diag.description;
      this.searchedDiags = [];
    },
    clickProc(proc) {
      this.officialProc = proc.code + " - " + proc.description;
      this.searchedProcs = [];
    },
    showAddProc() {
      if (
        !assertPrivilegeOrAlert(
          PRIVILEGES.PROCEDURE_ADD_UNORDERED,
          "You do not have permission to add procedures."
        )
      ) {
        return;
      }
      const isMobile = this.isMobile();
      const overlayId = isMobile 
        ? "procmodal-overlay-mobile" + this.patient.id
        : "procmodal-overlay" + this.patient.id;
      const overlay = document.getElementById(overlayId);
      if (overlay) {
        overlay.style.display = "flex";
      } else {
        $("#procmodal" + this.patient.id).css("display", "block");
      }
    },
    closeProc() {
      const isMobile = this.isMobile();
      const overlayId = isMobile 
        ? "procmodal-overlay-mobile" + this.patient.id
        : "procmodal-overlay" + this.patient.id;
      const overlay = document.getElementById(overlayId);
      const form = document.getElementById("procmodal" + this.patient.id);
      if (form) {
        form.reset();
      }
      if (overlay) {
        overlay.style.display = "none";
      } else if (form) {
        form.style.display = "none";
      }
      // Reset form state
      this.diagSearchCode = "";
      this.diagSearchDescrip = "";
      this.procSearchDescrip = "";
      this.officialProc = "";
      this.searchedProcs = [];
      this.searchedDiags = [];
      this.paginatedData = [];
    },
    async openOrderModal(orderId, procId) {
      if (!this.canOrderSign) {
        alert("You do not have permission to sign off on orders.");
        return;
      }
      try {
        let content = {
          MedicationAdmin: {
            API_Meth: "LookupOrderInfoSigSignOff",
            accountnumber: this.allData.patient.externId2,
            npinumber: this.allData.manager.externid || '',
            patientid: this.allData.patient.externId,
            ordernumber: orderId,
            medentryid: procId,
            provsubaccount: this.allData.manager.externid,
            type: "procedure"
          }
        };
        await axios.post(CURR_API + '/tswebhook.php', content)
          .then(response => {
            console.log(response.data);
            if (response.data && response.data.code == "200 Successfull" && response.data.results) {
              this.selectedOrder = response.data.results[0];
              console.log("Order LookUp Results");
              console.log(this.selectedOrder);
            }
          })
          .catch(error => {
            if (axios.isAxiosError(error)) {
              alert("Code:340 - System issue. Please contact system support");
              console.error('Error posting data:', error.response?.data || error.message);
            } else {
              alert("Oops, we hit an unexpected snag, please contact your system administrator if this error persists.");
              console.log('Unexpected error:', error);
            }
          });
        console.log("Order Id For the Order Template");
        console.log(orderId);
        console.log("Proc ID For Order Template");
        console.log(procId);
        this.showOrderModal = true;
      } catch (err) {
        console.error('Failed to load order', err);
      }
    },
    handleSubmit(nurseSignature) {
      console.log(nurseSignature);
      let content = {
        MedicationAdmin: {
          API_Meth: "UpdateOrderWithNurseSignature",
          accountnumber: this.allData.patient.externId2,
          patientid: this.allData.patient.externId,
          ordernumber: nurseSignature.ordernumber,
          nurseSignature: nurseSignature.nurseSignature,
          nurseSigDate: nurseSignature.nurseSignedDate,
          providerSignature: nurseSignature.provider,
          providerSignedDate: nurseSignature.providerSignedDate,
          action: nurseSignature.action,
          provsubaccount: this.allData.manager.externid
        }
      };
      axios.post(CURR_API + '/tswebhook.php', content)
        .then(response => {
          console.log(response.data);
          if (response.data && (response.data.code == "200 Successfull" || response.data.code == "200-Sql Success")) {
            alert("Signature updated successfully");
            this.loadProcedures();
            this.showOrderModal = false;
          } else {
            alert("Error updating signature. Please try again.");
          }
        })
        .catch(error => {
          if (axios.isAxiosError(error)) {
            alert("Code:340 - System issue. Please contact system support");
            console.error('Error posting data:', error.response?.data || error.message);
          } else {
            alert("Oops, we hit an unexpected snag, please contact your system administrator if this error persists.");
            console.log('Unexpected error:', error);
          }
        });
    },
  },
};
</script>
<style scoped lang="scss">
.header2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.title {
  margin-right: 20px;
}

.accordion {
  margin-top: 10px;
}

.accordion-item {
  border-bottom: 1px solid #d3d7db;
}

.accordion-button {
  padding: 15px;
  width: 100%;
  text-align: left;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 18px;
}

.accordion-content {
  display: none;
  padding: 15px;
}

.accordion-item.active .accordion-content {
  display: block; /* Show content when item is active */
}

body {
  margin: 0;
  padding: 0;
}
.container {
  margin: 20px auto;
  overflow-x: auto;
}
h2 {
  text-align: center;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}
th,
td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #d3d7db;
}
.button-container {
  text-align: center;
  margin: 20px 0;
}
.button-container button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
@media (max-width: 768px) {
  table,
  thead,
  tbody,
  th,
  td,
  tr {
    display: block;
  }
  th {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  tr {
    margin: 0 0 1rem 0;
    border: 1px solid #d3d7db;
  }
  td {
    border: none;
    border-bottom: 1px solid #d3d7db;
    position: relative;
    padding-left: 50%;
    white-space: normal;
    text-align: left;
  }
  td:before {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    white-space: nowrap;
    content: attr(data-label);
    font-weight: bold;
  }
}

.procrow {
  width: 40%;
}

.container {
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}
h2 {
  text-align: center;
}
.form-group {
  margin-bottom: 15px;
}
label {
  display: block;
  margin-bottom: 5px;
}
input[type="text"],
input[type="date"],
textarea {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #d3d7db;
  border-radius: 4px;
}
.form-group.inline {
  display: flex;
  justify-content: space-between;
}
.form-group.inline .form-control {
  flex: 1;
  margin-right: 10px;
}
.form-group.inline .form-control:last-child {
  margin-right: 0;
}
.form-buttons {
  display: flex;
  justify-content: space-between;
}
.form-buttons button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
@media (max-width: 600px) {
  .form-group.inline {
    flex-direction: column;
  }
  .form-group.inline .form-control {
    margin-right: 0;
    margin-bottom: 10px;
  }
  .form-buttons {
    flex-direction: column;
  }
  .form-buttons button {
    width: 100%;
    margin-bottom: 10px;
  }
}

/* Modal Overlay and Fixed Positioning */
.modal-overlay {
  /* Backdrop color + z-index from brand-ds (.eh-popup-overlay / --eh-popup-*). */
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.diagnosismodal {
  /* Layout matches pre-popup-chrome sizing so Save/Cancel stay in view. */
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  width: 70% !important;
  height: 70% !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  z-index: 10001 !important;
  display: none;
  /* Shared popup border/surface only — do not change size/position above. */
  border: var(--eh-popup-border) !important;
  border-radius: var(--eh-popup-radius) !important;
  background: var(--eh-popup-surface) !important;
  box-shadow: none !important;
}

.diagnosismodal.modal-visible {
  display: block;
}

.modal-overlay[style*="display: flex"] .diagnosismodal {
  display: block;
}

.mobile-proc-modal {
  width: 90% !important;
  overflow-y: auto !important;
}

.modal-overlay[style*="display: flex"] .mobile-proc-modal {
  display: block;
}

.sig-card {
  position: relative;
  display: inline-block;
  padding: 0px;
  border-radius: 8px;
  width: 75px;
  height: 0px;
  margin: 0px;
  z-index: 999;
  overflow: visible;
  cursor: pointer;
  vertical-align: middle;
  top: 0;
}

.signature-badge {
  position: absolute;
  top: 0;
  right: -26px;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px 10px 22px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 12px;
  line-height: 1;
  white-space: nowrap;
  pointer-events: auto;
  margin-top: 0;
}

.signature-badge::before {
  content: "";
  position: absolute;
  left: -18px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-right: 18px solid #cb5f50;
  z-index: -1;
}

.signature-badge .pen {
  flex: 0 0 auto;
  margin-left: 2px;
  opacity: 0.95;
}

.sig-text {
  display: inline-block;
  text-align: left;
}

@media (max-width: 420px) {
  .signature-badge {
    font-size: 11px;
    padding: 8px 12px 8px 18px;
    right: -20px;
  }
  .signature-badge::before {
    left: -14px;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 14px solid #cb5f50;
  }
}
</style>
